import script from "./leaves-admin-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./leaves-admin-modal.vue?vue&type=script&setup=true&lang=js"

import "./leaves-admin-modal.vue?vue&type=style&index=0&id=d6e00a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6e00a9a"]])

export default __exports__